import { unparse as convertToCSV } from "papaparse/papaparse.min";
import moment from "moment";

import { downloadCsv } from "../../utils";

export const exporter = (data) => {
  const dataForExport = data.map(item => ({
    Lote: item.cycle ? item.cycle.map(c => c.id).join(', ') : '',
    Pesquisa: item.question,
    Respostas: item.options ? item.options.map(option => option.value).join(', ') : '',
    'Respondido Por': item.answeredBy ? item.answeredBy.map(ab => ab.user.document).join(', ') : '',
    'Data de Criação': item.createdAt ? moment(item.createdAt).format('DD/MM/YYYY') : '',
  }));

  const csv = convertToCSV({
    data: dataForExport,
    fields: ['Lote', 'Pesquisa', 'Respostas', 'Respondido Por', 'Data de Criação'], // order fields in the export
  }, { delimiter: ';' });

  downloadCsv(csv, 'surveys'); 
};
